module.exports = __webpack_public_path__ + "img/bre1.7576bc97.png";